<template>
  <v-main style="margin: 1em; margin-top: 10vh">
    <v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
      class="text-sm-h6 text-md-h5"
    >
      Bienvenue dans votre espace CV. Dans cette section, vous pouvez générer
      des CV et consulter comment votre profil apparaît dans notre Cvthèque.
    </v-alert>

    <v-card flat>
      <v-toolbar
        dark
        flat
        style="
          background: url(https://picsum.photos/1920/1080?random) center
            no-repeat;
          background-size: cover;
        "
      >
        <v-toolbar-title class="text-h4 font-weight-thin" style="padding: 1em"
          >Espace Cv
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="#2196f3"></v-tabs-slider>

            <v-tab v-for="item in tabItems" :key="item">
              <span class="text-md-h6 text-sm-h6 font-weight-bold">{{
                item
              }}</span>
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab" style="">
        <v-tab-item :key="tabItems[0]">
          <CurrentResumes />
        </v-tab-item>
        <v-tab-item :key="tabItems[1]" style="overflow-y: scroll">
          <GenerateCV />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <Footer />
  </v-main>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";
import GenerateCV from "@/components/Candidate/GenerateCV.vue";
import CurrentResumes from "@/views/Candidate/CurrentResumes";

export default Vue.extend({
  name: "CandidateManageResume",
  components: { CurrentResumes, GenerateCV },
  data: () => ({
    tab: null,
    tabItems: ["CVs actuels", "Créer mon CV"],
  }),
  computed: {},

  watch: {},

  methods: {},
});
</script>

<style scoped></style>
